module.exports = __webpack_public_path__ + "static/media/hall1.9c3095a8.jpg";